// extracted by mini-css-extract-plugin
module.exports = {"header":"PatientGeneralDetailsHeader_header__qQDhu","date":"PatientGeneralDetailsHeader_date__2VcgJ","totalEcgs":"PatientGeneralDetailsHeader_totalEcgs__Lbv4a"};